/* eslint-disable no-constant-condition */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { fetchNotification } from '../../../../Redux/slices/notification';
import './styles.scss';
import { VscLoading } from 'react-icons/vsc';
import NotificationBar from '../../../../Components/NotificationBar';
import { Link } from 'react-router-dom';

function NotificationBox() {
  const dispatch = useDispatch();
  // eslint-disable-next-line no-unused-vars
  const notifications = useSelector((state) => state.notification.notifications);
  const loading = useSelector((state) => state.notification.loading);
  useEffect(() => {
    dispatch(fetchNotification());
  }, []);
  return (
    <div className="notificationBox-container">
      <h1>Notifications</h1>
      Earlier
      <div>
        <div className="notification-container">
          {loading ? (
            <div className="w-100 d-flex justify-content-center ">
              <VscLoading className="spin" />{' '}
            </div>
          ) : (
            <>
              {notifications?.map((notification) => (
                <NotificationBar notification={notification} key={notification.id} />
              ))}
            </>
          )}
        </div>
        <SeeMoreDiv to={'/admin/notifications'}>{!loading && 'See more'}</SeeMoreDiv>
      </div>
    </div>
  );
}

export default NotificationBox;

const SeeMoreDiv = styled(Link)`
  padding: 8px 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 2px solid #78787846;
  cursor: pointer;
  &:hover {
    background-color: #ccc;
  }
`;
